.link {
  display: inline-flex;
  align-self: flex-start;
  align-items: center;
  gap: 6px;
  min-height: 44px;
  color: var(--ink-2);
  font-size: 15px;
  font-weight: 500;
  text-decoration: none;
}

.arrow {
  width: 18px;
  height: 18px;
  background-color: currentColor;
  -webkit-mask: url('./back.svg') no-repeat center / contain;
  mask: url('./back.svg') no-repeat center / contain;
}
